import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text, { Inline } from 'components/base/Text';
import { getColor } from 'common/constants/_colors';

const StyledWrapper = styled(Flex)`
  background-color: ${getColor('white', 0.5)};
  padding: 3rem 5rem 0 5rem;
`;
const GitProviderInstructionsLayout = ({ children }) => (
  <StyledWrapper direction='column'>
    <Flex
      borderBox
      width='53.2rem'
      margin='0 5rem 4rem'
      items='center'
      direction='column'
    >
      <Text color='chambray' size='x-x-x-larger' weight='800'>
        JOIN THOUSANDS OF COMPANIES{' '}
      </Text>
      <Inline color='chambray' size='x-x-x-larger' weight='800'>
        THAT ARE ALREADY{' '}
        <Inline color='melrose' size='x-x-x-larger' weight='800'>
          USING LINEARB!
        </Inline>
      </Inline>
    </Flex>
    {children}
  </StyledWrapper>
);

export default GitProviderInstructionsLayout;
